
import Tween from "tween.ts";
import Animation from "../../animation/Animation";
import { shortestAngleDifference } from "../../utils/shortestAngleDifference";

export default class MovePointAnimation extends Animation {
  constructor(sRadian: number, radian: number, onUpdate: (a: number) => void, onComp: () => void) {
    super();
    const target = shortestAngleDifference(sRadian, radian) + sRadian;
    const a = { radian: sRadian }
    new Tween.Tween({ ...a })
      .to({ radian: target }, 1200)
      .easing(Tween.Easing.Linear.None)
      .onUpdate((a) => onUpdate(a.radian))
      .onComplete(() => onComp())
      .start();
  }
}